import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { combineLatest } from 'rxjs';
import { filter, map, startWith, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return combineLatest([
    auth.isAuthenticated$,
    auth.isLoading$,
    auth.error$.pipe(startWith(null))
  ]).pipe(
    filter(([, isLoading]) => !isLoading),
    take(1),
    map(([isAuthenticated, , error]) => {
      if (error) {
        router.navigate(['/error']);
        return false;
      }
      if (!isAuthenticated) {
        auth.loginWithRedirect({
          appState: { target: window.location.pathname }
        });
        return false;
      }
      return true;
    })
  );
};
